import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import InstagramIcon from '@material-ui/icons/Instagram';

const sidebar = {
    title: 'Education',
    school: 'THE OHIO STATE UNIVERSITY',
    dateRange: 'Jan 2007 - Dec 2011',
    description:
      'Bachelors of Science in Computer Science and Engineering. Concentration: Software Systems',
    contactName: 'Neil Davis',
    contactEmail: 'ndavisjr@gmail.com',
    contactPhone: '614-496-4230',
    contactLocation: 'Galveston, TX',
    social: [
      { name: 'GitHub', icon: GitHubIcon, link: 'https://github.com/ndavisjr' },
      { name: 'LinkedIn', icon: LinkedInIcon, link: 'https://www.linkedin.com/in/neil-davis-1b687a22/' },
      { name: 'Instagram', icon: InstagramIcon, link: 'https://www.instagram.com/davis_wx/' },
    ],
  };

  export default sidebar;